import mainImg from './mainImage.png';
import { BlockPage } from '../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';

export const ITDRBlockedPage = () => {
    const topics = [
        'Visualize all parts of an attack across your siloed identities in one placeholderCSS',
        'Identify and block attack techniques (TTPs), stopping threats like credential theft and lateral movementplaceholderCSS',
        'Automate responses for account lockdown, threat isolation, and moreplaceholderCSS'
    ];

    return (
        <BlockPage
            leftContent={{
                title: 'Identity Threat Detection and Response',
                image: mainImg
            }}
            rightContent={{
                icon: Icons.Target,
                title: 'Fortify All of Your Identities with ITDR',
                description:
                    'Detect and respond to identity-based threats in real time, overseeing all authentication and access attempts.',
                topics: topics,
                accessLink: 'https://www.silverfort.com/itdr-signup/?utm_source=PQL&utm_content=main'
            }}
        />
    );
};
